import React from 'react';

import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import WistiaVideo from 'core/modules/WistiaVideo/WistiaVideo';

import './VideoSection.scss';

function VideoSection() {
  const videoId = 'j0nfjpx0vp';

  return (
    <div className="mn_videoBlock">
      <ContentWrap>
        <SectionTitle title="Earning miles is easy" />
        <p>Want to maximize your earnings? See how it works.</p>
        <WistiaVideo videoId={videoId} />
      </ContentWrap>
    </div>
  );
}

export default VideoSection;
